import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'antd';

import { Namespace } from 'enums';
import { CompensationForm } from 'components/common';

import { useSubmitRequest } from './hooks';

export interface CreateCompensationModalProps {
  isOpen: boolean;
  isUserMode?: boolean;
  close: () => void;
  onSuccessSubmit?: () => void;
}

const formId = 'CREATE_COMPENSATION_FORM';

export const CreateCompensationModal = ({
  isOpen,
  close,
  isUserMode,
  onSuccessSubmit,
}: CreateCompensationModalProps) => {
  const { t } = useTranslation();

  const handleSuccessSubmit = useCallback(() => {
    close();
    onSuccessSubmit?.();
  }, [close, onSuccessSubmit]);

  const { handleSubmit, isLoading } = useSubmitRequest(handleSuccessSubmit);
  const [okDisabled, setOkDisabled] = useState(false);

  return (
    <Modal
      open={isOpen}
      title={t('createRequest', { ns: Namespace.PersonalArea })}
      onCancel={close}
      okText={t('submitCompensation', { ns: Namespace.CompensationForm })}
      cancelText={t('cancel')}
      confirmLoading={isLoading}
      okButtonProps={{ form: formId, htmlType: 'submit', disabled: okDisabled }}
      width={600}
      destroyOnHidden
    >
      <CompensationForm
        formId={formId}
        isUserMode={isUserMode}
        submit={handleSubmit}
        isNew
        close={close}
        onDisabledChange={setOkDisabled}
      />
    </Modal>
  );
};
